import React, { useContext, useEffect, useState } from "react";
import { Pane, Spinner, Text } from "evergreen-ui";
import ControlHubContext from "../contexts/controlhub";
import { API_URL } from "../config";

function ZohoScreen({ frameName }) {
  const { currentCompanyId } = useContext(ControlHubContext);
  const [isLoading, setIsLoading] = useState(false);
  const [frameUrl, setFrameUrl] = useState("");
  const [error, setError] = useState(null);

  useEffect(() => {
    if (currentCompanyId) {
      setIsLoading(true);
      fetch(
        `${API_URL}/admin/companies/${currentCompanyId}/integrations/zoho/embedded-url?url=${frameName}`,
        {
          credentials: "include",
        }
      )
        .then((res) => res.json())
        .then((data) => setFrameUrl(data.url))
        .catch((error) => {
          console.log(error);
          setError("An error ocurred, try refresh the page or log in again.");
        })
        .finally(() => setIsLoading(false));
    }
  }, [frameName, currentCompanyId]);

  if (isLoading) {
    return (
      <Pane
        height={240}
        alignItems="center"
        justifyContent="center"
        display="flex"
      >
        <Spinner />
      </Pane>
    );
  }

  if (error) {
    return (
      <Pane
        height={240}
        alignItems="center"
        justifyContent="center"
        display="flex"
      >
        <Text color="muted">{error}</Text>
      </Pane>
    );
  }

  if (!isLoading && frameUrl === null) {
    return (
      <Pane
        height={240}
        alignItems="center"
        justifyContent="center"
        display="flex"
      >
        <Text color="muted">
          {
            "Feature not enabled. Please contact support@controlhub.com if you're interested in this feature."
          }
        </Text>
      </Pane>
    );
  }

  return (
    <Pane paddingX={48}>
      {frameUrl && (
        <div className="h_iframe">
          <iframe
            title="Analytics"
            src={frameUrl}
            frameBorder="0"
            allowFullScreen
          />
        </div>
      )}
    </Pane>
  );
}

export default ZohoScreen;
